import { gql } from '@apollo/client'

export const singProductQuery = gql`
  query singleProduct($filter: JSON) {
    singleProduct(filter: $filter) {
      _id
      name
      code
      coverImage
      coverImageThumb
      status
      assets {
        _id
        url
        thumbUrl
        mediumUrl
        largeUrl
        type
        title
        subtitle
      }
      updatedAt
      price
      summary
      tags
      remarks
      fullDescription
      relatedProducts {
        _id
        code
        name
        coverImage
        coverImageThumb
        status
        inStock
      }
      relatedPosts {
        _id
        title
        summary
        cover
      }
      metadata {
        _id
        key
        value
        unit
        description
      }
      inStock
      originalPrice
      discountPercentage
      orderUom {
        _id
        code
        name
        symbol
      }
    }
  }
`
